import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericTilesComponent } from './generic-tiles.component';
import { MarkdownModule } from 'ngx-markdown';
import { TileModule, ModalModule, IconModule, TypeModule } from '@virginmediao2/momentum-angular';
import { LiveChatV3Module } from '@/shared/directives/live-chat-v3';
import { AnalyticsCTADirective } from '@/shared/directives/analytics-cta.directive';

@NgModule({
  declarations: [GenericTilesComponent],
  exports: [GenericTilesComponent],
  imports: [
    CommonModule,
    TileModule,
    MarkdownModule,
    LiveChatV3Module,
    ModalModule,
    IconModule,
    ModalModule,
    TypeModule,
    AnalyticsCTADirective
  ],
})
export class GenericTilesModule {}
